import script from "./StarBackground.vue?vue&type=script&setup=true&lang=js"
export * from "./StarBackground.vue?vue&type=script&setup=true&lang=js"

import "./StarBackground.vue?vue&type=style&index=0&id=7597bcc7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7597bcc7"]])

export default __exports__